import axios from '@/plugins/axios';
// import config from "../config";
// const baseDomain = config.baseURL();
// const baseURL = `${baseDomain}/api/`;

export default axios;
